import callAccountsApi from './data-provider'

export const getImageData = async key => {
  let result = await callAccountsApi('files','getImage',{key})

  if (!result || !result.bodyBase64)
  {
    return null
  }

  let buffer = Buffer.from(result.bodyBase64, 'base64')
  let blob = new Blob([buffer], { type: result.contentType })

  return {
    buffer,
    contentType: result.contentType,
    blobUrl: URL.createObjectURL(blob)
  }
}

export const saveImage = async ({ key, body, contentType, oldKey }) => {
  let bodyBase64 = Buffer.from(body).toString('base64')

  return await callAccountsApi('files','putImage',{
    key,
    bodyBase64,
    contentType,
    oldKey
  })
}

export const deleteImage = async key => {
  return await callAccountsApi('files','deleteImage',{ key })
}
